import Arizonaroad2 from "./reels/arizona-road-2.jpg";
import Arizonaroad3 from "./reels/arizona-road-3.jpg";
import Arizonaroad from "./reels/arizona-road.jpg";
import AztecTemple from "./reels/aztec-temple.jpg";
import BWwater from "./reels/b-w-water.jpg";
import BabyElephant2 from "./reels/baby-elephant-2.jpg";
import BabyElephant1 from "./reels/baby-elephant.jpg";
import BigBen from "./reels/big-ben.jpg";
import BikeSpoke from "./reels/bike-spokes.jpg";
import BloodMoon from "./reels/blood-moon.jpg";
import Butterfly from "./reels/butterfly.jpg";
import CactusAndCity from "./reels/cactus-and-city.jpg";
import CameraRigs from "./reels/camera-rigs.jpg";
import ChainLinkFence from "./reels/chain-link-fence.jpg";
import ColorfulArtPiece from "./reels/colorful-art-piece.jpg";
import ColorfulBuildings from "./reels/colorful-buildings.jpg";
import DessertCavern from "./reels/dessert-cavern.jpg";
import DessertSunset from "./reels/dessert-sunset.jpg";
import Dirt from "./reels/dirt.jpg";
import EdinburghCastle from "./reels/edinburgh-castle.jpg";
import ElephantFace from "./reels/elephant-face.jpeg";
import EuropeanCanal from "./reels/european-canal.jpg";
import EuropeanTrain from "./reels/european-train.jpg";
import FairAtNight from "./reels/fair-at-night.jpg";
import Fireworks from "./reels/fireworks.jpg";
import Fjord from "./reels/fjord.JPG";
import FlowersAndButterflies from "./reels/flowers-and-butterflies.jpg";
import FountainAtSunset from "./reels/fountain-at-sunset.jpg";
import FountainByLake from "./reels/fountain-by-lake.jpg";
import Giraffe from "./reels/giraffe.jpg";
import GoblinSmurf from "./reels/goblin-smurf.jpg";
import Gorilla from "./reels/gorilla.jpg";
import GrassAndBarn from "./reels/grass-and-barn.jpg";
import HouseOnLake from "./reels/house-on-lake.jpg";
import IcelandRollingHills from "./reels/iceland-rolling-hills.jpg";
import ImOnAMountain from "./reels/im-on-a-mountain.jpg";
import Jellyfish from "./reels/jelly-fish.jpg";
import Lava from "./reels/lava.JPG";
import LeavesOnLake from "./reels/leaves-on-lake.jpg";
import MoonPhases1 from "./reels/moon-phases-1.jpg";
import MoonPhases2 from "./reels/moon-phases-2.jpg";
import MoonPhases3 from "./reels/moon-phases-3.jpg";
import Mountain2 from "./reels/mountain-2.jpg";
import Mountain from "./reels/mountain.jpg";
import Neuschwanstein from "./reels/neuschwanstein.jpg";
import NightSky1 from "./reels/night-sky-1.jpg";
import NightSky2 from "./reels/night-sky-2.jpg";
import NightSky3 from "./reels/night-sky-3.jpg";
import OldTruck from "./reels/old-truck.jpg";
import PinkFlowers from "./reels/pink-flowers.jpg";
import PurpleFlowerCloseUp from "./reels/purple-flower-close-up.jpg";
import Rainbow from "./reels/rainbow.jpg";
import RiverBoat from "./reels/river-boat.JPG";
import RoadToCastle from "./reels/road-to-castle.jpg";
import Road from "./reels/road.JPG";
import SmallDessertWalkWAy from "./reels/small-dessertwalk-way.jpg";
import Stonehenge from "./reels/stonehenge.jpg";
import TownFromSidewalk from "./reels/town-from-sidewalk.jpg";
import Tree from "./reels/tree.jpg";
import TulipCloseUp from "./reels/tulip-close-up.jpg";
import VeniceCanals from "./reels/venice-canals.jpg";

export const photos = [
  {
    src: Arizonaroad2,
    width: 4,
    height: 5.35
  },
  {
    src: Arizonaroad3,
    width: 1,
    height: 1.334
  },
  {
    src: Arizonaroad,
    width: 3,
    height: 2
  },
  {
    src: AztecTemple,
    width: 3,
    height: 2.09
  },
  {
    src: BWwater,
    width: 3,
    height: 4
  },
  {
    src: BabyElephant2,
    width: 3,
    height: 2
  },
  {
    src: BabyElephant1,
    width: 3,
    height: 2.01
  },
  {
    src: BigBen,
    width: 3,
    height: 4
  },
  {
    src: BikeSpoke,
    width: 2,
    height: 1.51
  },
  {
    src: BloodMoon,
    width: 3,
    height: 1.9
  },
  {
    src: Butterfly,
    width: 3,
    height: 1.93
  },
  {
    src: CactusAndCity,
    width: 3,
    height: 2.25
  },
  {
    src: CameraRigs,
    width: 3,
    height: 2.22
  },
  {
    src: ChainLinkFence,
    width: 3,
    height: 3.29
  },
  {
    src: ColorfulArtPiece,
    width: 3,
    height: 2.26
  },
  {
    src: ColorfulBuildings,
    width: 3,
    height: 2.26
  },
  {
    src: DessertCavern,
    width: 3,
    height: 2.25
  },
  {
    src: DessertSunset,
    width: 3,
    height: 2.19
  },
  {
    src: Dirt,
    width: 3,
    height: 4
  },
  {
    src: EdinburghCastle,
    width: 3,
    height: 4
  },
  {
    src: ElephantFace,
    width: 3,
    height: 2.01
  },
  {
    src: EuropeanCanal,
    width: 3,
    height: 2.26
  },
  {
    src: EuropeanTrain,
    width: 3,
    height: 4
  },
  {
    src: FairAtNight,
    width: 3,
    height: 3.13
  },
  {
    src: Fireworks,
    width: 3,
    height: 2.01
  },
  {
    src: Fjord,
    width: 3,
    height: 4
  },
  {
    src: FlowersAndButterflies,
    width: 3,
    height: 3.62
  },
  {
    src: FountainAtSunset,
    width: 3,
    height: 4.79
  },
  {
    src: FountainByLake,
    width: 3,
    height: 4.51
  },
  {
    src: Giraffe,
    width: 3,
    height: 3.26
  },
  {
    src: GoblinSmurf,
    width: 3,
    height: 2.48
  },
  {
    src: Gorilla,
    width: 3,
    height: 2.01
  },
  {
    src: GrassAndBarn,
    width: 3,
    height: 2.26
  },
  {
    src: HouseOnLake,
    width: 3,
    height: 4.35
  },
  {
    src: IcelandRollingHills,
    width: 3,
    height: 4
  },
  {
    src: ImOnAMountain,
    width: 3,
    height: 4.71
  },
  {
    src: Jellyfish,
    width: 3,
    height: 4
  },
  {
    src: Lava,
    width: 3,
    height: 4.35
  },
  {
    src: LeavesOnLake,
    width: 3,
    height: 2.6
  },
  {
    src: MoonPhases1,
    width: 3,
    height: 3.01
  },
  {
    src: MoonPhases2,
    width: 3,
    height: 3.01
  },
  {
    src: MoonPhases3,
    width: 3,
    height: 3.01
  },
  {
    src: Mountain2,
    width: 3,
    height: 1.09
  },
  {
    src: Mountain,
    width: 3,
    height: 2.26
  },
  {
    src: Neuschwanstein,
    width: 3,
    height: 2.26
  },
  {
    src: NightSky1,
    width: 3,
    height: 4.95
  },
  {
    src: NightSky2,
    width: 3,
    height: 4.51
  },
  {
    src: NightSky3,
    width: 3,
    height: 2.04
  },
  {
    src: OldTruck,
    width: 3,
    height: 2.26
  },
  {
    src: PinkFlowers,
    width: 3,
    height: 2.01
  },
  {
    src: PurpleFlowerCloseUp,
    width: 3,
    height: 2
  },
  {
    src: Rainbow,
    width: 3,
    height: 4.01
  },
  {
    src: RiverBoat,
    width: 3,
    height: 2.19
  },
  {
    src: RoadToCastle,
    width: 3,
    height: 2.26
  },
  {
    src: Road,
    width: 3,
    height: 2.68
  },
  {
    src: SmallDessertWalkWAy,
    width: 3,
    height: 4
  },
  {
    src: Stonehenge,
    width: 3,
    height: 2.14
  },
  {
    src: TownFromSidewalk,
    width: 3,
    height: 2.26
  },
  {
    src: Tree,
    width: 3,
    height: 4
  },
  {
    src: TulipCloseUp,
    width: 3,
    height: 2
  },
  {
    src: VeniceCanals,
    width: 2,
    height: 1.5
  }
]